<template>
  <div>
    <section class="sectionStyle">
        <a-row type="flex" justify="space-between">
            <a-col :xs="24" :sm="24" :md="24" :lg="9">
                <div class="js_video">
                    <img :src="tenantConfig.competitionLeft ? tenantConfig.competitionLeft : '../../assets/imgs/shapes/video-1.jpg'" alt="">
                    <div class="play-btn">
                        <div class="video_player_btn">
                            <a :href="tenantConfig.competitionVideoUrl" target="_blank" class="popup-video"><i class="iconfont">&#xe867;</i></a>
                       </div>
                     </div> 
                </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="24" :lg="15"  class="js_content">
                <p class="modular_title animate__animated animate__fadeInLeftBig wow">竞赛集锦-学员风采</p>
                <p class="modular_title_en animate__animated animate__fadeInLeftBig wow" style="color: #fff">Competition Highlights and Students’Style</p>
                <swiper ref="mySwiperKc" :options="swiperOptionsJsjj" style="height: 500px;" class="swiper-wrappe carousel">
                    <swiper-slide class="swiper-slide"  v-for="(b,i) in list" :key="i">
                    <div class="js_list_box">
                        <div class="portrait_img">
                            <img :src="b.img" alt="">
                        </div>
                        <p class="js_name">{{ b.oneText }}</p>
                        <p class="js_stage_name">{{ b.twoText }}</p>
                        <div class="js_score">
                            <i class="iconfont" v-for="index in b.numer" :key="index">&#xe6a6;</i>
                        </div>
                        <p class="js_tips">{{ b.content }}</p>
                    </div>
                    </swiper-slide>
                    <div v-show="list && list.length > 1" class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
                </swiper>
            </a-col>
        </a-row>
    </section>
  </div>
</template>
<script>
export default {
  props:[],
  watch:{},
  name: '',
  components: {},
  data() {
    return {
        swiperOptionsJsjj:{
            autoplay:true,
            speed: 800,
            observer: true,
            observeParents: true,
            slidesPerView: 2, // 大于900像素时显示3个幻灯片
            spaceBetween: 20,  // 可选：设置间距
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            loop: true,
            breakpoints: {
                920: {  //当屏幕宽度小于等于1280
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                768: {  //当屏幕宽度小于等于768
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
            } 
        },
        list:[],
        value:4
    }
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo
        if (this.tenantConfig && this.tenantConfig.competitionImges) {
        var competitionImges = this.tenantConfig.competitionImges.split(",");
        if(this.tenantConfig.competitionOneText){
            var competitionOneText = this.tenantConfig.competitionOneText.split("\n")
        }else{
            var competitionOneText = []
        }
        if(this.tenantConfig.competitionTwoText){
            var competitionTwoText = this.tenantConfig.competitionTwoText.split("\n")
        }else{
            var competitionTwoText = []
        }
        if(this.tenantConfig.competitionNumberText){
            var competitionNumberText = this.tenantConfig.competitionNumberText.split("\n")
        }else{
            var competitionNumberText = []
        }
        if(this.tenantConfig.competitionContentText){
            var competitionContentText = this.tenantConfig.competitionContentText.split("\n")
        }else{
            var competitionContentText = []
        }
        for (var i in competitionImges) {
            var b = {};
            b.img = competitionImges[i];
            if(competitionOneText.length>i){
                b.oneText = competitionOneText[i]
            }
            if(competitionTwoText.length > i){
                b.twoText = competitionTwoText[i]
            }
            if(competitionNumberText.length > i){
                b.numer = competitionNumberText[i]*1
            }
            if(competitionContentText.length > i){
                b.content = competitionContentText[i]
            }
            this.list.push(b);
        }
        }
  },
  mounted() {},
  methods: {

  }
}
</script>
<style lang='less' scoped>
@media (max-width: 768px){
    .js_content{
        padding: 80px;
    }
}
    .sectionStyle{
        width: 100%;
        height: auto;
        padding: 0 0 40px ;
        position: relative;
        .js_video{
            width: 115%;
            height: 680px;
            position: relative;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .js_content{
            // position: absolute;
            // width: 100%;
            margin-top: 60px;
            padding:50px 25px;
            height: 680px;
            background: black;
            background-image: url('../../assets/imgs/shapes/shape-36.png');
        }
        .js_list_box{
            width: calc(100% - 53px);
            height: 60%;
            background: #fff;
            margin-top: 60px;
            margin-left: 50px;
            box-sizing: border-box;
            position: relative;
            border-left: 3px solid var(--primary-color);
            padding: 30px 20px 30px 70px;
            .portrait_img{
                width: 100px;
                height: 100px;
                border-radius: 50%;
                overflow: hidden;
                background: #fff;
                position: absolute;
                top: 0;
                bottom: 0;
                left: -50px;
                margin: auto;
            }
            p{
                margin: 0;
            }
            .js_name{
                font-size: 20px;
                color: black;
                font-weight: 600;
                line-height: 30px;
            }
            .js_stage_name{
                color: #787878;
                line-height: 26px;
            }
            .js_score{
                width: 100%;
                height: 30px;
                color: var(--primary-color);
            }
            .js_tips{
                font-size: 16px;
                color: #787878;
                line-height: 26px;
            }
        }
    }
</style>
